import { combineEpics, Epic } from 'redux-observable';

import { Action } from '../../actions';
import {
    changeReportsDomainColumnsOrder,
    changeReportsDomainColumnsVisibility,
    HANDLE_REPORTS_DOMAIN_COLUMNS_ORDER_CHANGE,
    HANDLE_REPORTS_DOMAIN_COLUMNS_VISIBILITY_CHANGE,
    HANDLE_REPORTS_DOMAIN_COLUMNS_WIDTH_UPDATE,
    HandleReportsDomainColumnsOrderChangeAction,
    HandleReportsDomainColumnsVisibilityChangeAction,
    HandleReportsDomainColumnsWidthUpdateAction,
    updateReportsDomainColumnsWidthData
} from '../../actions/reportsDomain';
import {
    getColumnSettingsWithUpdatedOrder,
    getColumnsVisibilitySettings,
    getColumnsWidthSettings
} from '../../service/ActionHelpers';
import { LocalStorage, StorageKeyType } from '../../service/Storage/Storage';
import { EpicDeps } from '../../service/StoreFactory';
import { reportsDomain } from '../../typings/common';
import { State } from '../../typings/state';

export const handleReportsDomainColumnsVisibilityChangeEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$
        .ofType(HANDLE_REPORTS_DOMAIN_COLUMNS_VISIBILITY_CHANGE)
        .map((action: HandleReportsDomainColumnsVisibilityChangeAction) => {
            const { columnsSettings } = store$.value.reportDomain;
            const settings = getColumnsVisibilitySettings(columnsSettings, action.columns, reportsDomain);

            LocalStorage.setItem(StorageKeyType.reportsDomainSettings, settings);

            return changeReportsDomainColumnsVisibility(settings);
        });
};

export const handleReportsDomainColumnsOrderChangeEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$
        .ofType(HANDLE_REPORTS_DOMAIN_COLUMNS_ORDER_CHANGE)
        .map((action: HandleReportsDomainColumnsOrderChangeAction) => {
            const { columnsSettings } = store$.value.reportDomain;

            const settings = getColumnSettingsWithUpdatedOrder(columnsSettings, action.columnOrder, reportsDomain);

            LocalStorage.setItem(StorageKeyType.reportsDomainSettings, settings);

            return changeReportsDomainColumnsOrder(settings[reportsDomain].columnOrder);
        });
};

export const handleReportsDomainColumnsWidthUpdateEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$
        .ofType(HANDLE_REPORTS_DOMAIN_COLUMNS_WIDTH_UPDATE)
        .map((action: HandleReportsDomainColumnsWidthUpdateAction) => {
            const { columnsSettings } = store$.value.reportDomain;
            const settings = getColumnsWidthSettings(columnsSettings, action.key, action.width, reportsDomain, false);

            LocalStorage.setItem(StorageKeyType.reportsDomainSettings, settings);

            return updateReportsDomainColumnsWidthData(settings);
        });
};

export const reportDomainHelpersEpic = combineEpics(
    handleReportsDomainColumnsVisibilityChangeEpic,
    handleReportsDomainColumnsOrderChangeEpic,
    handleReportsDomainColumnsWidthUpdateEpic
);
